import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Store } from '@ngrx/store';
import { ClientCustomizationDataDto } from 'src/app/services/api.services';
import { AppSelectors } from 'src/app/state/app';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
  standalone: false
})
export class SharedLayoutTopbarComponent implements AfterViewInit, OnInit {
  @Input() brand = true;
  @Input() previewOverrideEvent: EventEmitter<TopBarOverrideRequst>;

  @ViewChild('titleRef') titleRef: ElementRef;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private store: Store,
    private domsanitiser: DomSanitizer) { }

  
  originalCustomization: ClientCustomizationDataDto;
  clientCustomization: ClientCustomizationDataDto;
  logoUrl: string | SafeResourceUrl;

  isOverridden = false
  ngOnInit(): void {
    this.store.select(AppSelectors.clientCustomization).subscribe(data => {
      this.clientCustomization = data;
      this.originalCustomization = data;
      this.logoUrl = data?.logo?.url;
      this.changeDetectorRef.detectChanges();
    });

    this.previewOverrideEvent?.subscribe(e =>
      this.overridePreview(e));
  }

  ngAfterViewInit() {
    this.changeDetectorRef.detectChanges();
  }

  overridePreview(customization: TopBarOverrideRequst) {
    if (customization.enabled) {
      this.isOverridden = true;
      this.clientCustomization = customization.data;
      this.logoUrl = this.domsanitiser.bypassSecurityTrustResourceUrl(customization.data?.logo?.url);
    } else {
      this.resetOverridePreview()
      return;
    }
    this.changeDetectorRef.detectChanges();
  };

  resetOverridePreview() {
    this.clientCustomization = this.originalCustomization;
    this.logoUrl = this.originalCustomization.logo?.url;
    this.isOverridden = false;
    this.changeDetectorRef.detectChanges();
  };

  hasTitle() {
    return this.titleRef && this.titleRef.nativeElement.childNodes.length > 0;
  }
}
export interface TopBarOverrideRequst {
  enabled: boolean;
  data: ClientCustomizationDataDto;
}
